module.exports = __webpack_public_path__ + "static/media/james.f1d48213.jpg";